import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { User } from '../models/user';
import { map } from 'rxjs/operators';
import { DefaultPreferenceResponse } from '../models/defaultPreferenceResponse';
import { Application } from '../models/application';
import { UserService } from '../services/user.service'
import { DefaultPreferenceRequest } from '../models/defaultPreferenceRequest';
import { FrequencyMode } from '../models/FrequencyMode';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  /*
  This property is to hold user profile  details
  */
  userProfile: User;

  /*
  This property is to hold get default preference response obj
  */
  defaultPref: DefaultPreferenceResponse = new DefaultPreferenceResponse();

  /*
  This property is to hold get application response obj
  */
  applicationDetails: Application[] = [];
  private readonly _applications: BehaviorSubject<Application[]> = new BehaviorSubject<Application[]>([]);
  public applications$: Observable<Application[]> = this._applications.asObservable();

  /*
  This property is used to store api url that we from the environment.ts
  */
  private apiUrl = environment.apiUrl;

  /*
  This property is an observable for destoy
  */
  private onDestroy$ = new Subject<void>();

  public isChanged: boolean = false;


  private _savedUserPreference: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public savedUserPreference$: Observable<any[]> = this._savedUserPreference.asObservable();
  private _userPreference: BehaviorSubject<DefaultPreferenceResponse> = new BehaviorSubject<DefaultPreferenceResponse>(this.defaultPref);
  public userPreference$: Observable<DefaultPreferenceResponse> = this._userPreference.asObservable();

  constructor(private _authHttp: HttpClient, private userService: UserService) {
     this.userService.user$.subscribe(user=>{
      this.userProfile = user;
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
  }

  //This method is used to fetch saved user preference from API
  public getSavedUserPref(applicationId:string, userTimezoneOffset:number): Observable<any> {
    return this._authHttp.get(`${this.apiUrl}/v1/applications/${applicationId}/userTimezoneOffset/${userTimezoneOffset}/preferences`);
  }

  //This method is used to fetch default user preference from API
  public getDefaultUserPref(prefParams: DefaultPreferenceRequest): Observable<any> {
    return this._authHttp.get(`${this.apiUrl}/v1/applications/${prefParams.ApplicationId}`)
    .pipe(map((defaultPreferenceResponse:any)=>{
      if( defaultPreferenceResponse?.data?.categories?.length>0){
        defaultPreferenceResponse.data?.categories.forEach(category => 
          {
            if(category?.events.length>0){
              category.events.forEach(e => {
                if(e.frequencyTime && e.frequencyTime!=null && (e.frequencyMode ==FrequencyMode.Daily||e.frequencyMode ==FrequencyMode.Weekly)){
                  e.frequencyTime=this.convertToLocalTime(e.frequencyTime);
                } 
              });
            }
        });
      }
      return defaultPreferenceResponse;
    }));
  }

  //This method is used to fetch supported applications from API
  getApplications(userId: string): Observable<Application[]> {
    return this._authHttp.get<Application[]>(`${this.apiUrl}/v1/applications`).pipe(
      map((apps:any)=> apps.data.map(app=>{
        app.hideApplication=this.isAppHiddenForUser(app.id);
        return app;
      }))
    );
  }

  setApplications(apps: Application[]) {
    this.applicationDetails = apps;
    this._applications.next(apps);
  }

  public saveUserPreference(saveObj:any, userTimezoneOffset: number):Observable<any>{
    return this._authHttp.post(`${this.apiUrl}/v1/applications/${saveObj[0].ApplicationId}/userTimezoneOffset/${userTimezoneOffset}/preferences`, saveObj).pipe(map(res=>res));
  }
  convertToLocalTime(utcTimeString:string){
    const localTime=new Date(`2000-01-01T${utcTimeString}Z`);
    return localTime.toLocaleTimeString('en-US',{hour12:false});
  }
  isAppHiddenForUser(applicationId: string): boolean {
    const adminRole="admin";
    return environment.hideApps.includes(applicationId) &&
     !this.userProfile.roles.some(role=>role.toLocaleLowerCase()===adminRole.toLocaleLowerCase());
  }
}
